var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-sm font-family"},[_c('div',{staticClass:"container body serviceMain__body"},[_c('TopNavbar'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('p',{staticClass:"footer__text"},[_vm._v("資通行動科技"+_vm._s(_vm.VERSION))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0adaa110","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ServiceMain.vue
// module id = null
// module chunks = 